module.exports = __webpack_public_path__ + "img/master.6b50968c.webp";